import { useState } from "react";
import { useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import { useFetchData } from "../../hooks/useFetchData";
import { customStyles } from "../../utils/data/essential";
import paymentColumns from "../../utils/columns/paymentForAccountColumn";
import GenerateReceipt from "./GenerateReceipt";
import { selectPaymentLocation } from "../../redux/slice/paymentLocations";

const PaymentForAccount = ({ accountId }) => {
  const [payment, setPayment] = useState({});
  const [show, setShow] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'))
  const roles = JSON.parse(localStorage.getItem("roles"));
  const address = useSelector(selectPaymentLocation);
  const columns = paymentColumns(roles, setPayment, setShow);
    const url = `payments/collections?accountId=${accountId}`;
    const { data:payments } = useFetchData(["payment-for-account"],url,true,user)
  return (
    <>
      <div className='d-flex justify-content-center mt-4'>
        <h4 className='mt-3' style={{ fontWeight: 600 }}>
          {`${payments?.length === 0 ? "No" : ""} Payment${
            payments?.length > 1 ? "s" : ""
          } For This Account ${payments?.length === 0 ? "yet" : ""}`}
        </h4>
      </div>
      <div className='table-responsive datatables dataValidation-Wrap thead-primary pr-3 pl-3 mr-2'>
        <DataTable
          columns={columns}
          data={payments}
          responsive={true}
          customStyles={customStyles}
          pagination
          highlightOnHover
          striped
          noHeader
        />
      </div>
      <GenerateReceipt
        showReceipt={show}
        onHide={() => setShow(false)}
        payment={payment}
        address={address}
      />
    </>
  );
};

export default PaymentForAccount;
